import React from 'react';

export const NoNotes = () => {
  const styles = 'bg-dark-fill-blue border border-solid ' +
    'border-dark-border-blue color-grey text-center py-8 px-6 mb-6 rounded';

    return (
      <div className={styles}>
        No notes
      </div>
    );
};

export default NoNotes;
